import CookieConsentHelper from './cookie_consent_helper'

const embedlyCookieTypes = ['marketing']
export const embedlyGlobalSelector = '.embedly-init'
export const embedlyCardDataAttribute = 'data-embedly-card'
export const embedlyCardSelector = `[${embedlyCardDataAttribute}]`

// Copied and modified from embedly's docs.
/* eslint-disable */
function loadEmbedlyScript(w, d) {
  var id = 'embedly-platform',
    n = 'script'
  if (!d.getElementById(id)) {
    w.embedly =
      w.embedly ||
      function () {
        ;(w.embedly.q = w.embedly.q || []).push(arguments)
      }
    var e = d.createElement(n)
    e.id = id
    e.async = 1
    e.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js'
    var s = d.getElementsByTagName(n)[0]
    s.parentNode.insertBefore(e, s)
    // added:
    window.embedly('defaults', {
      cards: {
        key: '1cdf74229e6341f180e26198fe40468d'
      }
    })
  }
}
/* eslint-enable */

export function setupEmbedly(element) {
  const callback = () => {
    loadEmbedlyScript(window, document)
    if (element.matches(embedlyCardSelector)) {
      window.embedly('card', element)
    }
  }
  // some component on the page have a fallback behavior for when embedly is not available
  // in such cases, it's only necessary to warn about missing content when attempting to render an embed
  // not when loading embedly (loading embedly doesn't necessarily mean there are embed on the page)
  if (element.dataset.warn === 'false') {
    CookieConsentHelper.runWhenConsentGiven(embedlyCookieTypes, callback)
  } else {
    CookieConsentHelper.warnOrRunWhenConsentGiven(embedlyCookieTypes, callback)
  }
}
